import type { PaginationState } from '@tanstack/react-table'

/**
 * Lignes affichées par la page courante d'une liste paginée de `total` lignes, numérotées à partir
 * de 1 (« 26–50 sur 160 ») ; `0–0` pour une liste vide. Une page au-delà de la fin (liste
 * raccourcie entre-temps) ne donne pas de plage inversée.
 */
export const pageRange = (
  { pageIndex, pageSize }: PaginationState,
  total: number,
): { first: number; last: number } => {
  const last = Math.min((pageIndex + 1) * pageSize, total)
  return { first: total === 0 ? 0 : Math.min(pageIndex * pageSize + 1, last), last }
}
